export const GET_CONVERSATIONS = 'GET_CONVERSATIONS';